<script>
import { Switch as cSwitch } from '@coreui/vue'
import { Departamentos } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import axios from 'axios'
export default {
    name: 'AdicionalesDetraccionCarga',
     props:['editarAdicionales','modalEditarAdicionales'],
    components: {
      cSwitch,
      PulseLoader
  },
  data: () => {
    return {
      labelTxt: {
        dataOn: 'Si',
        dataOff: 'No'
      },
      modalAdicionalDetraccion: false,
      cargandoemisionDetraccion: false,
      tramoOrigen: 0,
      striped: true,
      small: true,
      outlined: true,
      bloqueUbigeoPartida: true,
      bloqueUbigeoLlegada: true,
      bloqueUbigeoTramoOrigen: true,
      detalleViaje: '',
      valorReferencialServicioTransporte: '',
      valorReferencialCargaActiva: '',
      valorReferencialCargaUtil: '',
      puntoOrigenViaje: '',
      puntoDestinoViaje: '',
      descripcionTramo: '',
      montoReferencialPreliminar: '',
      configuracionVehicular: '',
      cargaUtilTmVehiculo: '',
      cargaEfectivaTmVehiculo: '',
      valorReferencialPorTm: '',
      valorPreliminarCargaUtil: '',
      listDepartamento: Departamentos,
      indFactorRetornoViaje: false,
      modalUbigeoDestino: false,
      modalUbigeoPartida: false,
      distDestino: false,
      distDestinoCargando: false,
      provDestino: false,
      provDestinoCargando: false,
      distDestinoTramo: false,
      distDestinoCargandoTramo: false,
      provDestinoTramo: false,
      provDestinoCargandoTramo: false,
      provOrigen: false,
      provOrigenCargando: false,
      distOrigen: false,
      distOrigenCargando:  false,
      provOrigenTramo: false,
      provOrigenCargandoTramo: false,
      distOrigenTramo: false,
      distOrigenCargandoTramo:  false,
      prependUbigeoOrigen: '',
      prependUbigeoDestino: '',
      placeholderUbigeoPartida: 'Ubigeo Part.',
      placeholderUbigeoLlegada: 'Ubigeo LLeg.',
      placeholderUbigeoPartidaTramo: 'Ubigeo Part.',
      placeholderUbigeoLlegadaTramo: 'Ubigeo Lleg.',
      departamentoSeleccionadoUbigeoOrigen: '00',
      provinciaSeleccionadaUbigeoOrigen: '',
      distritoSeleccionadoUbigeoOrigen: '',
      departamentoSeleccionadoUbigeoDestino: '00',
      provinciaSeleccionadaUbigeoDestino: '',
      distritoSeleccionadoUbigeoDestino: '',
      departamentoSeleccionadoUbigeoOrigenTramo: '00',
      provinciaSeleccionadaUbigeoOrigenTramo: '',
      distritoSeleccionadoUbigeoOrigenTramo: '',
      departamentoSeleccionadoUbigeoDestinoTramo: '00',
      provinciaSeleccionadaUbigeoDestinoTramo: '',
      distritoSeleccionadoUbigeoDestinoTramo: '',
      listDepartmentOrigen: [],
      listProvinceOrigen: [],
      listDistrictOrigen: [],
      listDepartmentDestino: [],
      listProvinceDestino: [],
      listDistrictDestino: [],
      ubigeoPartida: '',
      direccionPartida: '',
      ubigeoLlegada: '',
      direccionLlegada: '',
      // Detraccion - Servicion transporte de carga
      adicionalDetraccion: {
        servicioTransporteCarga: {
          ubigeoOrigen: '',
          direccionOrigen: '',
          ubigeoDestino: '',
          direccionDestino: '',
          detalleViaje: '',
          valorReferencialServicioTransporte: 0,
          valorReferencialCargaActiva: 0,
          valorReferencialCargaUtil: 0,
          detalleTramos: []
        }
      },
      tramo: {
        identificadorTramo: '',
        puntoOrigenViaje: '',
        puntoDestinoViaje: '',
        descripcionTramo: '',
        montoReferencialPreliminar: 0.00,
        configuracionVehicular: '',
        cargaUtilTmVehiculo: 0.00,
        cargaEfectivaTmVehiculo: 0.00,
        valorReferencialPorTm: 0.00,
        valorPreliminarCargaUtil: 0.00,
        indFactorRetornoViaje: false
      },
      tramos: [],
      tramos_fields: [
        {key: 'puntoOrigenViaje', label: 'Origen', sorteable: true},
        {key: 'puntoDestinoViaje', label: 'Destino', sorteable: true},
        {key: 'descripcionTramo', label: 'Descripcion', sorteable: true},
        {key: 'montoReferencialPreliminar', label: 'Referencial', sorteable: true},
        {key: 'configuracionVehicular', label: 'Vehiculo', sorteable: true},
        {key: 'acciones', label: 'Acciones', sorteable: true},
      ],
      sendArrayTrasporte:[]
    }
  },
  watch: {
    distritoSeleccionadoUbigeoOrigenTramo: function () {
        this.distOrigenCargandoTramo = false,
        this.puntoOrigenViaje = this.departamentoSeleccionadoUbigeoOrigenTramo + this.provinciaSeleccionadaUbigeoOrigenTramo + this.distritoSeleccionadoUbigeoOrigenTramo.codDistrito,
        this.bloqueUbigeoTramoOrigen = true
    },
    provinciaSeleccionadaUbigeoOrigenTramo: function () {
        this.distOrigenTramo = true,
        this.distOrigenCargandoTramo = true,
        this.searchDistrictOrigen(this.distOrigenCargando, 2)
    },
    departamentoSeleccionadoUbigeoOrigenTramo: function () {
        this.provOrigenTramo = true,
        this.searchProvinceOrigen(2)
    },
    distritoSeleccionadoUbigeoDestinoTramo: function () {
        this.distDestinoCargandoTramo = false,
        this.puntoDestinoViaje = this.departamentoSeleccionadoUbigeoDestinoTramo + this.provinciaSeleccionadaUbigeoDestinoTramo + this.distritoSeleccionadoUbigeoDestinoTramo.codDistrito,
        this.bloqueUbigeoTramoOrigen = true
    },
    provinciaSeleccionadaUbigeoDestinoTramo: function () {
        this.distDestinoTramo = true,
        this.distDestinoCargandoTramo = true,
        this.searchDistrictDestino(this.distDestinoCargandoTramo, 2)
    },
    departamentoSeleccionadoUbigeoDestinoTramo: function () {
        this.provDestinoTramo = true,
        this.searchProvinceDestino(2)
    },
    distritoSeleccionadoUbigeoOrigen: function () {
        this.distOrigenCargando = false,
        this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
        this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
        this.bloqueUbigeoPartida = true
    },
    provinciaSeleccionadaUbigeoOrigen: function () {
        this.distOrigen = true,
        this.distOrigenCargando = true,
        this.searchDistrictOrigen(this.distOrigenCargando, 1)
    },
    departamentoSeleccionadoUbigeoOrigen: function () {
        this.provOrigen = true,
        this.searchProvinceOrigen(1)
    },
    distritoSeleccionadoUbigeoDestino: function () {
        this.distDestinoCargando = false,
        this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
        this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre,
        this.bloqueUbigeoLlegada = true
    },
    provinciaSeleccionadaUbigeoDestino: function () {
        this.distDestino = true,
        this.distDestinoCargando = true,
        this.searchDistrictDestino(this.distDestinoCargando, 1)
    },
    departamentoSeleccionadoUbigeoDestino: function () {
        this.provDestino = true,
        this.searchProvinceDestino(1)
    },
    'modalEditarAdicionales':function(){
        if(this.modalEditarAdicionales){
            this.editarTrasporteCarga();
        }
    }
  },
  methods: {
      validateTotalDatosDetraccion: function () {
        let arrayValorDetraccionTrasporte = {
            valorTrasporte : this.valorReferencialServicioTransporte
        }
        this.sendArrayTrasporte.push(arrayValorDetraccionTrasporte)

          if(this.ubigeoPartida != '' && 
            this.direccionPartida != '' && 
            this.ubigeoLlegada != '' && 
            this.direccionLlegada != '' && 
            this.detalleViaje != '' &&
            this.valorReferencialServicioTransporte != '' &&
            this.valorReferencialCargaActiva != '' && 
            this.valorReferencialCargaUtil != '' &&
            this.adicionalDetraccion.servicioTransporteCarga.detalleTramos.length > 0)
            {
                this.adicionalDetraccion.servicioTransporteCarga.ubigeoOrigen = this.ubigeoPartida
                this.adicionalDetraccion.servicioTransporteCarga.direccionOrigen = this.direccionPartida
                this.adicionalDetraccion.servicioTransporteCarga.ubigeoDestino = this.ubigeoLlegada
                this.adicionalDetraccion.servicioTransporteCarga.direccionDestino = this.direccionLlegada
                this.adicionalDetraccion.servicioTransporteCarga.detalleViaje = this.detalleViaje
                this.adicionalDetraccion.servicioTransporteCarga.valorReferencialServicioTransporte = parseFloat(this.valorReferencialServicioTransporte)
                this.adicionalDetraccion.servicioTransporteCarga.valorReferencialCargaActiva = parseFloat(this.valorReferencialCargaActiva)
                this.adicionalDetraccion.servicioTransporteCarga.valorReferencialCargaUtil = parseFloat(this.valorReferencialCargaUtil)
                this.adicionalDetraccionBack(this.adicionalDetraccion,this.sendArrayTrasporte)
                this.modalAdicionalDetraccion = false
          }else{
              this.$snotify.warning('Revisa que los datos esten completos!', 'Cuidado'),
              this.modalAdicionalDetraccion = true
          }
      },
      addItemDetraccion: function () {
        let tramo = {}
        let cantidadTramos = this.tramos.length
        tramo.identificadorTramo = (cantidadTramos +1)
        tramo.puntoOrigenViaje = this.puntoOrigenViaje
        tramo.puntoDestinoViaje = this.puntoDestinoViaje
        tramo.descripcionTramo = this.descripcionTramo
        tramo.montoReferencialPreliminar = parseFloat(this.montoReferencialPreliminar)
        tramo.configuracionVehicular = this.configuracionVehicular
        tramo.cargaUtilTmVehiculo = parseFloat(this.cargaUtilTmVehiculo)
        tramo.cargaEfectivaTmVehiculo = parseFloat(this.cargaEfectivaTmVehiculo)
        tramo.valorReferencialPorTm = parseFloat(this.valorReferencialPorTm)
        tramo.valorPreliminarCargaUtil = parseFloat(this.valorPreliminarCargaUtil)
        tramo.indFactorRetornoViaje = this.indFactorRetornoViaje
        this.adicionalDetraccion.servicioTransporteCarga.detalleTramos.push(tramo)
        tramo = {}
        this.identificadorTramo = this.tramos.length
        this.puntoOrigenViaje = ''
        this.puntoDestinoViaje = ''
        this.descripcionTramo = ''
        this.montoReferencialPreliminar = ''
        this.configuracionVehicular = ''
        this.cargaUtilTmVehiculo = ''
        this.cargaEfectivaTmVehiculo = ''
        this.valorReferencialPorTm = ''
        this.valorPreliminarCargaUtil = ''
        this.indFactorRetornoViaje = false
      },
      deleteItemDetraccion: function (value) {
            this.adicionalDetraccion.servicioTransporteCarga.detalleTramos.splice(value,1)
      },
      asignUbigeoOrigenDistrito: function (val) {
      if(val == 1){
        this.ubigeoOrigen = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito
        this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre
      }else if(val == 2){
        this.puntoOrigenViaje = this.departamentoSeleccionadoUbigeoOrigenTramo + this.provinciaSeleccionadaUbigeoOrigenTramo + this.distritoSeleccionadoUbigeoOrigenTramo.codDistrito
        this.bloqueUbigeoTramoOrigen = false
      }
    },
    asignUbigeoDestinoDistrito: function () {

    },
    searchDepartmentOrigen: function () {
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
          token: this.$store.getters.userToken
      })
      .then(response => (
          this.listDepartmentOrigen = response.data                       
      ))
      .catch(error => {})
    },
    searchProvinceOrigen: function (ind) {
      let departamentoActual = ''
      if(ind == 1){
          departamentoActual = this.departamentoSeleccionadoUbigeoOrigen
          this.provOrigenCargando = true
      }else if(ind == 2){
          departamentoActual = this.departamentoSeleccionadoUbigeoOrigenTramo
          this.provOrigenCargandoTramo = true
      }
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
          token: this.$store.getters.userToken,
          department: departamentoActual
      })
      .then(response => (
          this.listProvinceOrigen = response.data,
          this.provOrigenCargando = false, 
          this.provOrigenCargandoTramo = false                       
      ))
      .catch(error => {})
    },
    searchDistrictOrigen: function (value, ind) {
      let departmentActual = ''
      let provinceActual = ''
      if(ind == 1){
        departmentActual = this.departamentoSeleccionadoUbigeoOrigen,
        provinceActual = this.provinciaSeleccionadaUbigeoOrigen,
        this.distOrigenCargando = value
      }else if(ind == 2){
        departmentActual = this.departamentoSeleccionadoUbigeoOrigenTramo,
        provinceActual = this.provinciaSeleccionadaUbigeoOrigenTramo,
        this.distOrigenCargandoTramo = value   
      }
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
          token: this.$store.getters.userToken,
          department: departmentActual,
          province: provinceActual
      })
      .then(response => (
          this.listDistrictOrigen = response.data,
          this.distOrigenCargando = false,
          this.distOrigenCargandoTramo = false
      ))
      .catch(error => {})
    },
    searchDepartmentDestino: function () {
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
          token: this.$store.getters.userToken
      })
      .then(response => (
          this.listDepartmentDestino = response.data                       
      ))
      .catch(error => {})
    },
    searchProvinceDestino: function (ind) {
      let departamentoActual = ''
      if(ind == 1){
          departamentoActual = this.departamentoSeleccionadoUbigeoDestino,
          this.provDestinoCargando = true
      }else if(ind == 2){
          departamentoActual = this.departamentoSeleccionadoUbigeoDestinoTramo,
          this.provDestinoCargandoTramo = true
      }
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
          token: this.$store.getters.userToken,
          department: departamentoActual
      })
      .then(response => (
          this.listProvinceDestino = response.data,
          this.provDestinoCargando = false,
          this.provDestinoCargandoTramo = false                       
      ))
      .catch(error => {})
    },
    searchDistrictDestino: function (value, ind) { 
      let departmentActual = ''
      let provinceActual = ''
      if(ind == 1){
        departmentActual = this.departamentoSeleccionadoUbigeoDestino,
        provinceActual = this.provinciaSeleccionadaUbigeoDestino,
        this.distDestinoCargando = value
      }else if(ind == 2){
        departmentActual = this.departamentoSeleccionadoUbigeoDestinoTramo,
        provinceActual = this.provinciaSeleccionadaUbigeoDestinoTramo,
        this.distDestinoCargandoTramo = value 
      }
      axios
      .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
          token: this.$store.getters.userToken,
          department: departmentActual,
          province: provinceActual
      })
      .then(response => (
          this.listDistrictDestino = response.data,
          this.distDestinoCargando = false,
          this.distDestinoCargandoTramo = false  
      ))
      .catch(error => {})
    },
    validateItemDetraccion: function () {
      if(this.puntoOrigenViaje != '' && 
        this.puntoDestinoViaje != '' && 
        this.descripcionTramo != '' && 
        this.montoReferencialPreliminar != '' && 
        this.configuracionVehicular != '' &&
        this.cargaUtilTmVehiculo != '' && 
        this.cargaEfectivaTmVehiculo != '' && 
        this.valorReferencialPorTm != '' &&
        this.valorPreliminarCargaUtil != ''
        )
        {
            return true
        }else{
            return false
        }
    },
    ubigeosTramos: function (ind) {
        if(ind == 1){
            this.bloqueUbigeoTramoOrigen=false
            this.tramoOrigen = 1
        }else if(ind == 2){
            this.bloqueUbigeoTramoOrigen=false
            this.tramoOrigen = 2
        }else{
            this.bloqueUbigeoTramoOrigen=true
            this.tramoOrigen = 0
        }
    },
    adicionalDetraccionBack: function (value,destracciontrasporte){
        this.$emit("detraccion", value),
        this.$emit("ValordetraccionTrasporte", destracciontrasporte),
        this.ubigeoPartida = '',
        this.direccionPartida = '', 
        this.ubigeoLlegada = '', 
        this.direccionLlegada = '',
        this.detalleViaje = '',
        this.valorReferencialServicioTransporte = '',
        this.valorReferencialCargaActiva = '',
        this.valorReferencialCargaUtil = '',
        this.prependUbigeoOrigen = '',
        this.prependUbigeoDestino = '',
        this.adicionalDetraccion = {
            servicioTransporteCarga: {
            ubigeoOrigen: '',
            direccionOrigen: '',
            ubigeoDestino: '',
            direccionDestino: '',
            detalleViaje: '',
            valorReferencialServicioTransporte: 0,
            valorReferencialCargaActiva: 0,
            valorReferencialCargaUtil: 0,
            detalleTramos: []
            }
        }
    },
    editarTrasporteCarga(){
        let datos = this.editarAdicionales
        this.ubigeoPartida = datos.ubigeoOrigen,
        this.direccionPartida = datos.direccionOrigen,
        this.ubigeoLlegada = datos.ubigeoDestino,
        this.direccionLlegada = datos.direccionDestino,
        this.detalleViaje = datos.detalleViaje,
        this.valorReferencialServicioTransporte = datos.valorReferencialServicioTransporte,
        this.valorReferencialCargaActiva = datos.valorReferencialCargaActiva,
        this.valorReferencialCargaUtil = datos.valorReferencialCargaUtil,
        this.adicionalDetraccion.servicioTransporteCarga.detalleTramos = datos.detalleTramos;       
    },
}
}
</script>

<template>
    <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <b-button size="sm" v-b-modal.adicionalDetraccion class="colorestelemovil">Datos adicionales <b-badge variant="success"> Nuevo</b-badge></b-button>
            <b-modal size="lg" id="adicionalDetraccion" v-model="modalAdicionalDetraccion" centered title="Operación Sujeta a Detracción- Servicios de Transporte Carga">
                <b-row v-if="bloqueUbigeoPartida">
                    <b-col cols="2">
                        <b-btn  @click="bloqueUbigeoPartida=false"><i class="fa fa-suitcase"> Origen</i></b-btn>
                    </b-col>
                    <b-col cols="2">
                        <b-form-input
                            class="input-requerido"
                            type="text"
                            v-model="ubigeoPartida"
                            required
                            :placeholder="placeholderUbigeoPartida">
                        </b-form-input>
                    </b-col>
                    <b-col cols="8">
                        <b-input-group size="md" :prepend="prependUbigeoOrigen">
                            <b-form-input 
                                class="input-requerido"
                                type="text"
                                v-model="direccionPartida"
                                required
                                placeholder="Dirección de Partida">
                            </b-form-input>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="3">
                        <template>
                            <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoOrigen">
                                <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                            </select>
                        </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!provOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                            <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigen">
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!distOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona un Distrito...">
                                </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                            <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigen">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
                    <b-col cols="3">
                    <b-btn  @click="bloqueUbigeoPartida=true" class="backubigeopartida"><i class="fa fa-backward"> Atras</i></b-btn>
                    </b-col>
                </b-row>
                <br>
                <b-row v-if="bloqueUbigeoLlegada">
                <b-col cols="2">
                    <b-btn  @click="bloqueUbigeoLlegada=false"><i class="fa fa-suitcase"> Destino</i></b-btn>
                </b-col>
                <b-col cols="2">
                    <b-form-input
                        class="input-requerido"
                        type="text"
                        v-model="ubigeoLlegada"
                        required
                        :placeholder="placeholderUbigeoLlegada">
                    </b-form-input>
                </b-col>
                <b-col cols="8">
                    <b-input-group size="md" :prepend="prependUbigeoDestino">
                        <b-form-input
                            class="input-requerido"
                            type="text"
                            v-model="direccionLlegada"
                            required
                            placeholder="Dirección de Llegada">
                        </b-form-input>
                    </b-input-group>
                </b-col>
                </b-row>
                <b-row v-else>
                <b-col cols="3">
                    <template>
                        <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestino">
                            <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                        </select>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!provDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="provDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestino">
                                <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!distDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="distDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestino">
                                <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
                <b-col cols="3">
                    <b-btn  @click="bloqueUbigeoLlegada=true" class="backubigeopartida"><i class="fa fa-backward"> Atras</i></b-btn>
                </b-col>
                </b-row>
                <br>
                <b-row>
                <b-col cols="12">
                    <b-form-input v-model="detalleViaje" class="form-control input-placedark input-dark" placeholder="Detalle Viaje" required/>
                </b-col>
                </b-row><br>
                <b-row>
                <b-col cols="4">
                    <b-form-input v-model="valorReferencialServicioTransporte" class="form-control input-placedark input-dark" placeholder="Valor referencial del servicio" required/>
                </b-col>
                <b-col cols="4">
                    <b-form-input v-model="valorReferencialCargaActiva" class="form-control input-placedark input-dark" placeholder="Valor referencial de la carga activa" required/>
                </b-col>
                <b-col cols="4">
                    <b-form-input v-model="valorReferencialCargaUtil" class="form-control input-placedark input-dark" placeholder="Valor referencial de la carga util" required/>
                </b-col>
                </b-row><br>
                <b-row>
                <b-alert show variant="primary">
                    <b-row v-if="bloqueUbigeoTramoOrigen">
                        <b-col cols="3">
                            <b-btn @click="ubigeosTramos(1)"><i class="fa fa-suitcase"> Ubigeo Origen</i></b-btn>
                        </b-col>
                        <b-col cols="3">
                            <b-form-input
                                class="input-requerido"
                                type="text"
                                v-model="puntoOrigenViaje"
                                required
                                >
                            </b-form-input>
                        </b-col>
                        <b-col cols="3">
                            <b-btn  @click="ubigeosTramos(2)"><i class="fa fa-suitcase"> Ubigeo Destino</i></b-btn>
                        </b-col>
                        <b-col cols="3">
                            <b-form-input
                                class="input-requerido"
                                type="text"
                                v-model="puntoDestinoViaje"
                                required
                                >
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <template v-if="tramoOrigen == 1">
                            <b-col cols="3">
                                <template>
                                    <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoOrigenTramo">
                                        <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                    </select>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <template>
                                    <div v-if="!provOrigenTramo">
                                        <b-form-input 
                                            type="text"
                                            disabled
                                            placeholder="Selecciona una Provincia...">
                                        </b-form-input>
                                    </div>
                                    <div v-else-if="provOrigenCargandoTramo">
                                    <pulse-loader></pulse-loader>
                                    </div>
                                    <div v-else>
                                        <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigenTramo">
                                            <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                        </select>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <template>
                                    <div v-if="!distOrigenTramo">
                                        <b-form-input 
                                            type="text"
                                            disabled
                                            placeholder="Selecciona un Distrito...">
                                        </b-form-input>
                                    </div>
                                    <div v-else-if="distOrigenCargandoTramo">
                                        <pulse-loader></pulse-loader>
                                    </div>
                                    <div v-else>
                                        <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigenTramo">
                                            <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                        </select>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <b-btn  @click="ubigeosTramos(0)" class="backubigeopartida"><i class="fa fa-backward"> Atras</i></b-btn>
                            </b-col>
                        </template>
                        <template v-else-if="tramoOrigen == 2">
                            <b-col cols="3">
                                <template>
                                    <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestinoTramo">
                                        <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                                    </select>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <template>
                                    <div v-if="!provDestinoTramo">
                                        <b-form-input 
                                            type="text"
                                            disabled
                                            placeholder="Selecciona una Provincia...">
                                        </b-form-input>
                                    </div>
                                    <div v-else-if="provDestinoCargandoTramo">
                                    <pulse-loader></pulse-loader>
                                    </div>
                                    <div v-else>
                                        <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestinoTramo">
                                            <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                        </select>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <template>
                                    <div v-if="!distDestinoTramo">
                                        <b-form-input 
                                            type="text"
                                            disabled
                                            placeholder="Selecciona un Distrito...">
                                        </b-form-input>
                                    </div>
                                    <div v-else-if="distDestinoCargandoTramo">
                                        <pulse-loader></pulse-loader>
                                    </div>
                                    <div v-else>
                                        <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestinoTramo">
                                            <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                        </select>
                                    </div>
                                </template>
                            </b-col>
                            <b-col cols="3">
                                <b-btn  @click="ubigeosTramos(0)" class="backubigeopartida"><i class="fa fa-backward"> Atras</i></b-btn>
                            </b-col>
                        </template>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="6">
                            <b-form-input v-model="descripcionTramo" class="form-control input-placedark input-dark" placeholder="Descripcion del Tramo" required/>                        
                        </b-col>
                        <b-col cols="6">
                            <b-form-input v-model="configuracionVehicular" class="form-control input-placedark input-dark" placeholder="Configuración vehicular" required/>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="6">
                             <b-form-input  style="border-color:green;border-width: 2px;" v-model="montoReferencialPreliminar" class="form-control input-placedark input-dark" placeholder="Monto referecial preliminar S/" required/>
                        </b-col>
                        <b-col cols="6">
                            <b-form-input  style="border-color:green;border-width: 2px;" v-model="valorReferencialPorTm" class="form-control input-placedark input-dark" placeholder="Valor referencial por tramo S/" required/>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="6">
                            <b-form-input  style="border-color:brown;border-width: 2px;" v-model="cargaUtilTmVehiculo" class="form-control input-placedark input-dark" placeholder="Cargar útil por tramo peso en Tm" required/>
                            
                        </b-col>
                        <b-col cols="6">
                            <b-form-input  style="border-color:green;border-width: 2px;" v-model="valorPreliminarCargaUtil" class="form-control input-placedark input-dark" placeholder="Valor preliminar de la carga útil S/" required/>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="6">
                            <b-form-input  style="border-color:brown;border-width: 2px;" v-model="cargaEfectivaTmVehiculo" class="form-control input-placedark input-dark" placeholder="Carga efectiva por tramo peso en Tm" required/>
                        </b-col>
                        <b-col cols="3">
                            <b-input-group class="retornarDetraccion">
                                <label class="agregaritemsnew">Retornar? </label>
                                <c-switch class="mx-1 cargaritemsPersonalizado" color="primary" v-model="indFactorRetornoViaje" label outline="alt" variant="pill" v-bind="labelTxt" />
                            </b-input-group>
                        </b-col>
                        <b-col cols="3">
                            <template v-if="validateItemDetraccion()">
                            <button v-if="!cargandoemisionDetraccion" size="sm" class="btn btn-primary agregartramo" @click.prevent="addItemDetraccion(true)"><i class="fa fa-map"></i> Agregar Tramo</button>
                            <button v-else class="btn btn-seconday agregartramo" size="sm"><i class="fa fa-spin fa-spinner"></i> Agregar Tramo</button>
                            </template>
                            <template v-else>
                            <button class="btn btn-secondary agregartramo" size="sm" disabled><i class="fa fa-map"></i> Agregar Tramo</button>
                            </template>
                        </b-col>
                    </b-row>
                </b-alert>
                </b-row>
                <br>
                <b-row>
                <b-table responsive
                    :small="small"
                    :items="adicionalDetraccion.servicioTransporteCarga.detalleTramos"
                    :fields="tramos_fields"
                    :outlined="outlined"
                    >
                    <template slot="acciones" slot-scope="row">
                    <b-row>
                        <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItemDetraccion(row.index)"><i class="fa fa-trash danger"></i></button>
                    </b-row>
                    </template>
                </b-table>
                </b-row>
                <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" @click="validateTotalDatosDetraccion">
                    Cargar Adicionales
                </b-btn>
                </div>
            </b-modal>
        </b-col>
        </b-row>
</template>

<style>
    
</style>